<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "4rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><path d="M49 9H15a2 2 0 00-2 2v42a2 2 0 002 2h34a2 2 0 002-2V11a2 2 0 00-2-2zm-1 3v31H16V12zM16 52v-7h32v7z"/><circle cx="32" cy="48.5" r="1.5"/></svg>